// src/components/ui/calendar/week/WeekViewHeader/WeekViewHeaderShadcn.jsx
import React from 'react';
import { cn } from '../../../../../utils/cn';
import { CalendarDateHeaderShadcn } from '../../core';

const WeekViewHeaderShadcn = ({
  weekDates,
  currentDate,
  className = ''
}) => {
  console.log('🔍 WeekViewHeader received weekDates:', weekDates);
  console.log('🔍 WeekViewHeader received currentDate:', currentDate);

  if (weekDates) {
    weekDates.forEach((date, index) => {
      console.log(`🔍 Date ${index}:`, date, 'Type:', typeof date);
    });
  }

  const today = new Date().toDateString();

  return (
    <div className={cn(
      // Container with spacer for hour label column
      "flex bg-slate-800/40 border-b border-slate-600/30",
      className
    )}>
      {/* Spacer for hour label column */}
      <div className="w-14 flex-shrink-0" />

      {/* Week dates grid */}
      <div className="flex-1 grid grid-cols-7">
        {weekDates.map((date, index) => (
          <CalendarDateHeaderShadcn
            key={index}
            date={date}
            view="week"
            isToday={date.toDateString() === today}
            isSelected={date.toDateString() === currentDate.toDateString()}
            className="border-r border-slate-600/30 last:border-r-0"
          />
        ))}
      </div>
    </div>
  );
};

export default WeekViewHeaderShadcn;